<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>老师({{teacherList.length}})</h1>
        <router-link class="pull-right icon-right icon-setup text-hide" :to="{path:'/invitation/teacher'}" tag="span">更多</router-link>
      </div>
      <div class="liner"></div>
    </div>


    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page">
      <div>
        <ul class="list-group-item primary">
          <li class="list-group" v-for="item in teacherList">
            <div class="liner"></div>
            <router-link class="group-link clearfix" :to="{path:'/teacher/detail/'+item.teacherId}">
              <div class="img-wrap pull-left small">
                <img :src="item.teacherIcon ? (item.baseAcessPath + item.teacherIcon) : img_default"/></div>
              <span class="group-txt">
                <span class="block clearfix">
                  <cite class="font-16 pull-left">{{item.teacherName}}</cite>
                  <!-- <span class="gray margin-x-15 font-12 pull-right" v-if="item.className">{{item.className}} - {{item.jobName}}</span>
                  <span class="orange margin-x-15 font-12 pull-right" v-else>暂未关联班级 - {{item.jobName}}</span> -->
                  <!--span class="gray margin-x-15 font-12">{{item.className ? item.className : "未关联班级"}}-{{ item.jobName }}</span-->
                  <span class="gray margin-x-15 font-12 pull-right" >{{item.jobName}}</span>
                </span>
                <cite class="gray hide">{{ item.phoneNum }}</cite>
              </span>
            </router-link>
          </li>
        </ul>

        <ul class="bg-white">
          <li>
            <div class="liner"></div>
            <div class="font-12" style="padding:15px 10px">
              <p class=" font-16 margin-15">*温馨提示</p>
              <p class="gray margin-15">管理员有添加或删除老师的权限。<br>超级管理员除了一般管理员权限外，可以将老师提升为管理员权限，也可以将管理员降为老师权限。<br>老师只有一般的管理权限。</p>
              <p class="gray margin-15"></p>
              <p class="gray margin-15"></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    </mt-loadmore>

    <div class="bottom-bar hide" v-if="cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2"> <!--v-link="{path:'/curche/detail'}" href="javascript:;"-->
      <router-link class="button button-block button-primary" :to="{path:'/teacher/add'}">添加老师</router-link>
    </div>
    <div class="bottom-bar hide" v-if="cookie_login_data.jobId == 8 || cookie_login_data.jobId == 9 || cookie_login_data.jobId == 10 || cookie_login_data.jobId == 3"> <!--v-link="{path:'/curche/detail'}" href="javascript:;"-->
      <a class="button button-block button-primary"  @click.prevent="toastShow('您没有添加权限')">添加老师</a>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    teacherList: 'teacherList'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_curche_teacher_para: service.setPara('getCurcheTeacher')
    }
  },
  mounted: function () {
    this.get_curche_teacher_para.curcheId = this.cookie_login_data.curcheId
    this.get_curche_teacher_para.context = this
    this.getCurcheTeacher()
  },
  methods: {
    ...mapMutations([
      'clearTeachers',
      'receiveTeachers'
    ]),
    loadTop (id) {
      this.$store.dispatch('clearTeachers')
      this.getCurcheTeacher()
      this.$refs.loadmore.onTopLoaded(id)
    },
    getCurcheTeacher: function () {
      this.$store.dispatch('receiveTeachers', this.get_curche_teacher_para)
    },
    toastShow: function (msg) {
      Toast(msg)
    }
  }
}
</script>


// WEBPACK FOOTER //
// TeacherManage.vue?7a40b26a